import React, { useEffect, useRef } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutionsSection } from './components/FailedSolutionsSection';
import { MechanismSection } from './components/MechanismSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FaqSection } from './components/FaqSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { Separator } from './components/Separator';
import { initPixel, trackPageView } from './lib/meta-pixel';
export function App() {
  const pricingRef = useRef<HTMLElement>(null);
  const scrollToPricing = () => {
    pricingRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-stone-950 text-stone-50 font-heading selection:bg-amber-500/30 dark" data-id="element-0">
      <HeroSection onCtaClick={scrollToPricing} data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedSolutionsSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <DeliverablesSection data-id="element-5" />
      <Separator className="bg-stone-900" data-id="element-6" />
      <AudienceSection data-id="element-7" />
      <HowItWorksSection data-id="element-8" />
      <ProofSection data-id="element-9" />
      <FaqSection data-id="element-10" />
      <PricingSection ref={pricingRef} data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}